// React
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// FutureLab
import Logo from '../components/common/Logo';
import { getPwaToken } from '../utilities/authCookie';
import { pwaRoutes } from '../utilities/pwaRoutes';

export function LoginPage() {
	const navigate = useNavigate();
	let storedPathName = localStorage.getItem('redirectTo');

	useEffect(() => {
		if (getPwaToken()) {
			if (!storedPathName || storedPathName === '/login') {
				storedPathName = '/';
			}

			navigate(storedPathName);
			localStorage.removeItem('redirectTo');
			return;
		}

		window.location.assign(pwaRoutes.login());
	}, []);

	return (
		<div className="mx-auto flex min-h-full w-full min-w-0 max-w-sm flex-col items-center gap-6 px-4 py-8 text-center sm:px-6 sm:py-12">
			<Logo />
			<div className="w-full min-w-0 rounded-xl border border-border bg-card p-5 shadow-sm sm:p-6">
				<h1 className="break-words text-xl font-medium text-foreground">Redirecting to sign in...</h1>
			</div>
		</div>
	);
}
